const setUserLocation = async () => {
  try {
    const data = await fetch(process.env.REACT_APP_API_GEOIP).then((res) => res.json())
    const isEurope = data.eu === '1'
    if (!isEurope) {
      window.initGTM && window.initGTM()
    }
    window.userLocation = data
  } catch (e) {
    window.initGTM && window.initGTM()
    window.userLocation = { country: 'US', eu: 0 }
  }
}

const getUserLocation = () => {
  return window.userLocation ? window.userLocation : {country: 'US', eu: 0}
}

export {getUserLocation, setUserLocation}
